// Moved from `src/hooks/query/useQueryOrganizationMembers.ts` (now a shim)
// with OT3 (ARCFE-954). Token-seam severance: the `@/store` token read
// becomes the injected reactive `useAuthToken` (the entitlements precedent —
// the key set stays identical; only the gating input's source changes). The
// user read composes the package hook. `console.error` and the null-swallow
// on failure are the hook's frozen behaviour — preserved, not improved.
import { useQuery } from '@tanstack/react-query';

import type { OrganizationMemberOrdering } from '@heidi/schema/ml-scribe';

import { GET_ORGANIZATION_MEMBERS } from '../../contracts/keys';
import { getOrganizationMembers } from '../api/organization';
import { getWorkspaceDataConfig } from '../config';
import { useQueryUser } from './useQueryUser';

export { GET_ORGANIZATION_MEMBERS };

export function useQueryOrganizationMembers(
  organizationId?: string,
  // TODO: add type for input from schema
  input?: {
    page?: number;
    pageSize?: number;
    orderBy?: OrganizationMemberOrdering;
    isDescending?: boolean;
    search?: string;
    teamIds?: string[];
    roleIds?: string[];
    specialtyIds?: string[];
    showPendingInvitationsOnly?: boolean;
  }
) {
  const token = getWorkspaceDataConfig().useAuthToken();
  const { data: userData } = useQueryUser();
  return useQuery({
    queryKey: [GET_ORGANIZATION_MEMBERS, organizationId, input],
    retry: 3,
    enabled: !!token && !!userData && !!organizationId,
    queryFn: async () => {
      try {
        if (!organizationId) {
          return null;
        }
        const { data } = await getOrganizationMembers(organizationId, {
          page: input?.page,
          pageSize: input?.pageSize,
          orderBy: input?.orderBy,
          isDescending: input?.isDescending,
          search: input?.search,
          teamIds: input?.teamIds,
          roleIds: input?.roleIds,
          specialtyIds: input?.specialtyIds,
          showPendingInvitationsOnly: input?.showPendingInvitationsOnly,
        });
        return data;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
  });
}
